var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBalearicIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8365 0 32 7.16349 32 16C32 24.8365 24.8365 31.9999 16 31.9999C7.16355 31.9999 6.10352e-05 24.8365 6.10352e-05 16",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6526 7.11122H29.3053C28.4063 5.76829 27.3093 4.56954 26.0561 3.55566H15.6526V7.11122Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6526 14.2222H31.9016C31.7652 12.9894 31.4889 11.7989 31.0887 10.6667H15.6526V14.2222Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91175 21.3334H31.0883C31.4884 20.2013 31.7648 19.0107 31.9012 17.7778H0.098877C0.235127 19.0108 0.511501 20.2013 0.91175 21.3334Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94461 28.4445H26.0561C27.3091 27.4307 28.4063 26.2318 29.3053 24.8889H2.69556C3.59455 26.2318 4.69155 27.4306 5.94461 28.4445Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16349 0 -6.24995e-05 7.16349 4.08967e-10 16.0001C3.65162 16 7.16349 16.0001 16 16.0001L16 0Z",
    fill: "#4A1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2177 8.34785V9.73916H12.5221V8.34785H11.1308V9.73916H10.4351V6.95654H7.65251V9.73916H6.95682V8.34785H5.56557V9.73916H4.86989V8.34785H3.47852V12.5217H14.609V8.34785H13.2177Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBalearicIslands);
export default __webpack_public_path__ + "static/media/flag_balearic_islands.0f2253469664de68992d5aec32f01600.svg";
export { ForwardRef as ReactComponent };